import { Component, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Observable } from 'rxjs';
import { BudgetWorksheet } from '../../data-services/rate-planning';
import * as fromDataServices from '../../data-services';
import { filter, map, take, takeWhile } from 'rxjs/operators';
import clone from 'just-clone';
import { select, Store } from '@ngrx/store';
import * as fromShared from '../../shared';
import moment from 'moment';
import * as fromLookups from '../../lookups/store';

@Component({
    selector: 'ef-rate-planning-feature',
    templateUrl: './rate-planning-feature.component.html',
    styleUrls: ['./rate-planning-feature.component.scss'],
    standalone: false
})
export class RatePlanningFeatureComponent implements OnInit {
    process$: Observable<fromShared.Process>;
    public budgetWorksheet$: Observable<BudgetWorksheet[]>;

    ratePlanningDataService: EntityCollectionService<BudgetWorksheet>;

    fiscalYears$: Observable<fromShared.SelectItem[]>;

    active: boolean = true;

    constructor(private store: Store, public entityServices: EntityServices) {
        this.ratePlanningDataService =
            entityServices.getEntityCollectionService<fromDataServices.RatePlanning.BudgetWorksheet>(
                fromDataServices.RatePlanning.entityName
            );
    }

    ngOnInit(): void {
        // this.store.dispatch(
        //     fromLookups.ScheduledDateActions.clearScheduledDates()
        // );
        fromLookups.ScheduledDateActions.clearScheduledDates();
        this.store.dispatch(
            fromLookups.ScheduledDateActions.getScheduledDates({
                ShowAll: true
            })
        );
        this.setupObservables();
        this.setupSubscriptions();
    }

    ngOnDestroy() {
        this.ratePlanningDataService.clearCache();
        this.active = false;
    }

    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.budgetWorksheet$ = this.ratePlanningDataService.entities$.pipe(
            map(x => clone(x))
        );
        this.fiscalYears$ = this.store.pipe(
            select(
                fromLookups.ScheduledDateSelectors.selectScheduledDateType({
                    ScheduledDateType: 'FYE'
                })
            ),

            //filter(dates => !!dates && dates.length > 0),
            //take(1),
            map(items =>
                items.map(item => ({
                    label: moment(item.ScheduledEndDate).format('L'),
                    value: moment(item.ScheduledEndDate).format('L')
                }))
            )
        );
    }

    setupSubscriptions() {
        this.fiscalYears$
            .pipe(takeWhile(() => this.active), take(1))
            .subscribe(years => {
                this.ratePlanningDataService.clearCache();
                this.ratePlanningDataService.getWithQuery({
                    BudgetEnd: years[0].value,
                    costcenterid: null,
                    CalcRates: 1 as any
                });
            });
    }

    onUpdateRatePlanning($event) {
        this.ratePlanningDataService.upsert($event);
        console.dir($event);
    }

    onLoadRatePlanning($event) {
        this.ratePlanningDataService.clearCache();
        this.ratePlanningDataService.getWithQuery({
            BudgetEnd: $event.BudgetEnd,
            costcenterid: null,
            CalcRates: $event.CalcRates
        });
    }

    onLoadCalcRates($event) {
        //this.ratePlanningDataService.clearCache();
        this.ratePlanningDataService.getWithQuery({
            BudgetEnd: $event.BudgetEnd,
            costcenterid: null,
            CalcRates: $event.CalcRates
        });
    }
}
